


























































































import { factionDesc, factionName } from "../data/factions";

import { Component, Prop, Vue } from "vue-property-decorator";
import Engine, { Expansion, Faction, factionPlanet, factionVariantBoard } from "@gaia-project/engine";
import { finalScoringFields, finalScoringItems } from "../logic/final-scoring-rules";
import { factionColor, planetFill } from "../graphics/utils";
import { tradeHeaders, tradeRows } from "../logic/trade-rewards";
import RichTextView from "./Resources/RichTextView.vue";

type Rule = Faction | "rules" | "scoring" | "trade";
@Component({
  components: { RichTextView },
})
export default class Rules extends Vue {
  @Prop()
  id: string;

  @Prop({ default: "rules" })
  type: Rule;

  private rule: Rule = "rules";

  private finalScoringFields: any[] = null;
  private finalScoringItems: any[] = null;

  get engine(): Engine {
    return this.$store.state.data;
  }

  get isFrontiers(): boolean {
    return this.engine.expansions === Expansion.Frontiers;
  }

  mounted() {
    this.finalScoringFields = finalScoringFields();
    this.finalScoringItems = finalScoringItems();

    this.selectRule(this.type ?? "rules");
  }

  get tradeHeaders() {
    return tradeHeaders();
  }

  get tradeRows() {
    return tradeRows();
  }

  selectRule(rule: Rule) {
    this.rule = rule;
  }

  get factions(): Faction[] {
    return Object.values(Faction);
  }

  factionName(faction: Rule): string {
    return factionName(faction as Faction);
  }

  backgroundColor(rule: Rule): string {
    return factionColor(rule as Faction);
  }

  color(rule: Rule): string {
    return planetFill(factionPlanet(rule as Faction));
  }

  get factionTooltip(): string {
    const faction = this.rule as Faction;

    const player = this.engine.players.find((p) => p.faction == faction);
    const variant = player?.variant?.board ?? factionVariantBoard(this.engine.factionCustomization, faction)?.board;
    return factionDesc(faction, variant, this.engine.expansions);
  }
}
